import React from 'react';
import { Line, Bar } from 'react-chartjs-2';
import Chart from 'chart.js/auto';
import zoomPlugin from 'chartjs-plugin-zoom';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { chartOptions, chartTypes } from './constants.constants';
import ToggleHighlightButtons from '../ToggleHighlightButtons';
import DeviceIcons from '../../deviceList/DeviceIcons';
import LoadingSpinner from '../LoadingSpinner';
import { getDevicesConsApi, getDevicesEventsApi } from '../../api/api';

import ToggleTime from './ToggleTime';

Chart.register(zoomPlugin);

function getTimeFormatted(time, interval, timeZone = 'UTC') {
  const date = new Date(time);
  const options = {
    day: '2-digit',
    month: '2-digit',
    timeZone: timeZone || 'UTC',
  };

  if (interval === 'hour' || !interval) {
    options.hour = '2-digit';
    options.minute = '2-digit';
  }
  return date.toLocaleString('ru-RU', options).replace(',', '');
}

const Chartjs = ({ device, timeZone }) => {
  const [chData, setChData] = React.useState({});
  const [cons, setCons] = React.useState(false);
  const isSensor = device?.type.key === 'sensor';

  const getData = async (from, to, period) => {
    if (cons) {
      await getDevicesCons(from, to, period);
    } else {
      const periodForEvent = !isSensor ? period : undefined;
      await getDevicesEvents(from, to, periodForEvent);
    }
  };

  const [devicesEventsErr, setDevicesEventsErr] = React.useState([]);

  const getDevicesEvents = async (from, to, interval) => {
    await getDevicesEventsApi(
      { deviceId: device.id, from, to, interval },
      function (data) {
        const devType = device?.type?.sub_type?.key;

        let chart = { ...chartTypes[devType] };
        chart.labels = [...data.map((e) => getTimeFormatted(e.at, interval, timeZone))];
        chart.datasets = chart.datasets.map((ds, i) => ({
          ...ds,
          data: [...data.map((e) => e.value)],
        }));
        setChData(chart);
      },
      function (err) {
        toast.error(err.error, { hideProgressBar: true });
        setDevicesEventsErr((p) => [...p, err]);
      }
    );
  };

  const getDevicesCons = async (from, to, interval) => {
    await getDevicesConsApi(
      { deviceId: device.id, from, to, interval },
      function (data) {
        let devType = device?.type?.sub_type?.key + ':cons';

        let chart = { ...chartTypes[devType] };
        chart.labels = [...data.map((e) => getTimeFormatted(e.interval, interval, timeZone))];
        chart.datasets = chart.datasets.map((ds) => ({
          ...ds,
          data: [...data.map((e) => e.consumption)],
        }));

        setChData(chart);
      },
      function (err) {
        toast.error(err.error, { hideProgressBar: true });
        setDevicesEventsErr((p) => [...p, err]);
      }
    );
  };

  const switchType = async (isCons) => {
    setChData({});
    setDevicesEventsErr([]);
    setCons(isCons);
  };

  return (
    <>
      {device?.type?.sub_type?.key.includes('counter') && (
        <>
          <div className="flex items-center bg-gray-100 rounded-full px-3 py-3 mb-4">
            <DeviceIcons device={device}></DeviceIcons>
            <div className="ml-4 flex-1">
              <p className="truncate">{device?.type?.name}</p>
              <p className="truncate text-sm text-gray-400">{device?.serial_number}</p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-2 pb-4">
            <ToggleHighlightButtons highlighted={cons} title1={'Расход'} title2={'Показания счетчика'} btnCb={switchType} />
          </div>
        </>
      )}

      <ToggleTime getData={getData} cons={cons} />
      {chData.labels && chData.datasets[0].data ? (
        <div className="w-full  h-60 sm:h-60 md:h-72 xl:h-96 2xl:h-96">
          {chData.type === 'line' && <Line data={chData} options={chartOptions} />}
          {chData.type === 'bar' && <Bar data={chData} options={chartOptions} />}
        </div>
      ) : (
        <div className="flex w-full h-60 sm:h-60 md:h-72 xl:h-96 2xl:h-96 items-center justify-center">
          <LoadingSpinner error={devicesEventsErr} loading={true} style=""></LoadingSpinner>
        </div>
      )}
    </>
  );
};

export default Chartjs;
